export default "__VITE_ASSET__bf25fe8a__"